import { CommonModule, NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { FormlyModule } from "@ngx-formly/core";
import { BadgeModule } from "primeng-v17/badge";
import { MenubarModule } from "primeng-v17/menubar";
import { PanelModule } from "primeng-v17/panel";
import { SimpleMenubarComponent } from "../../shared/components/simple-menu-bar/simple-menu-bar.component";
import { ObserveLocalStoragePipe } from "../../shared/pipes/observe-local-storage.pipe";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { NewUiFormlyMenuBarComponent } from "./new-ui-formly-menu-bar.component";

@Component({
  selector: "app-formly-menu-bar",
  templateUrl: "./formly-menu-bar.component.html",
  styleUrl: "./formly-menu-bar.component.scss",
  imports: [
    CommonModule,
    NgIf,
    FormlyModule,
    MenubarModule,
    PanelModule,
    TranslateDirective,
    BadgeModule,
    ObserveLocalStoragePipe,
    SimpleMenubarComponent,
  ],
})
export class FormlyMenuBarComponent extends NewUiFormlyMenuBarComponent {}
